import { render, staticRenderFns } from "./collectRecord.vue?vue&type=template&id=7532b1e0&scoped=true"
import script from "./collectRecord.vue?vue&type=script&lang=js"
export * from "./collectRecord.vue?vue&type=script&lang=js"
import style0 from "./collectRecord.vue?vue&type=style&index=0&id=7532b1e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7532b1e0",
  null
  
)

export default component.exports